import React from 'react';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { ToggleButton, darken, lighten } from '@mui/material';
import colors from 'src/utils/colors';
import RuleStore from './stores';

export const RuleDays = React.memo(() => {
  const { days: dayState, toggleDay } = RuleStore((s) => ({
    days: s.days,
    toggleDay: s.toggleDay
  }));

  const days = Object.keys(dayState);

  return (
    <Flex
      flexDirection="column"
      sx={{
        marginBottom: '40px'
      }}
    >
      <Text variant="h7">Days</Text>
      <Flex
        gap={24}
        sx={{
          marginTop: '8px'
        }}
      >
        {days.map((day) => (
          <ToggleButton
            key={day}
            color="primary"
            selected={dayState[day]}
            onClick={() => toggleDay(day)}
            value={day}
            sx={{
              padding: '6px 22px',
              color: colors.darkBlue,
              border: `1px solid ${colors.graysSecondary}`,
              borderRadius: '4px',
              transition: 'background-color 0.3s ease',
              textTransform: 'unset',
              fontWeight: 400,
              fontFamily: 'Roboto',
              '&:hover': {
                backgroundColor: darken(colors.white, 0.05)
              },
              '&.Mui-selected': {
                backgroundColor: colors.darkBlue,
                color: 'white',
                border: `1px solid ${colors.darkBlue}`,
                '&:hover': {
                  backgroundColor: lighten(colors.darkBlue, 0.05)
                }
              }
            }}
          >
            {day}
          </ToggleButton>
        ))}
      </Flex>
    </Flex>
  );
});

RuleDays.displayName = 'RuleDays';
